import _styled from "styled-components";
const _excluded = ["style", "className", "children", "initialExpanded", "multiExpand", "renderItem"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { getValidChildren } from '@adsk/alloy-react-helpers';
import { stylePropType } from '@adsk/alloy-react-theme';
import AccordionItem from './AccordionItem';
import useAccordion from './hooks/useAccordion';
/**
 * An accordion component.
 */
const Accordion = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      children,
      initialExpanded,
      multiExpand,
      renderItem = itemProps => /*#__PURE__*/React.createElement(AccordionItem, itemProps)
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    getItemProps
  } = useAccordion({
    initialExpanded,
    multiExpand,
    itemCount: React.Children.toArray(children).length
  });
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    className: className,
    ref: ref
  }, props, {
    $_css: [{
      width: '100%'
    }, style]
  }), React.Children.map(getValidChildren(children), (child, index) => renderItem(_objectSpread(_objectSpread({}, getItemProps({
    index
  })), child.props))));
});
Accordion.displayName = 'Accordion';
Accordion.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The accordion items that make up this Accordion */
  children: PropTypes.any,
  /** An array of item indexes to expand initially */
  initialExpanded: PropTypes.arrayOf(PropTypes.number.isRequired),
  /** Whether or not multiple items can be expanded at once */
  multiExpand: PropTypes.bool,
  /** Render custom accordian item */
  renderItem: PropTypes.func
};
export default Accordion;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Accordion___StyledDiv",
  componentId: "sc-8eyb94-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Accordion.js.map